import { ButtonSocial } from '~/components/Buttons/ButtonSocial'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import FacebookIcon from '~/components/Icons/svgs/FacebookIcon'

import useShowSubscriptionPackagesPageAfterSSO from '~/hooks/useShowSubscriptionPackagesPageAfterSSO'

import useAuthenticateWithFacebook from '../hooks/useAuthenticateWithFacebook'

export default function ButtonFacebookLogin({
  buttonText,
  className = '',
  disabled,
  redirectBack,
}: {
  buttonText?: string
  className?: string
  disabled?: boolean
  redirectBack?: boolean
}): React.ReactElement {
  const { loading, handleLoginWithFacebook } = useAuthenticateWithFacebook(redirectBack)
  useShowSubscriptionPackagesPageAfterSSO()

  return (
    <ButtonSocial
      className={`flex-1 w-full ${buttonText ? '' : 'rounded-4'} ${className}`}
      disabled={disabled}
      isFullWidth
      isLoading={loading}
      onClick={handleLoginWithFacebook}
      size="small"
      socialType="facebook"
      spinnerColor="purple"
    >
      <div className="relative w-full flex items-center justify-center">
        <div className={`h-full rounded ${buttonText ? 'absolute left-0 -mt-1' : 'mx-auto'}`}>
          <SVGIcon icon={FacebookIcon} pathClassName="text-white" />
        </div>
        {buttonText && <div className="text-sm font-semibold z-10">{buttonText}</div>}
      </div>
    </ButtonSocial>
  )
}
